<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.deliveryDates' | translate}}</span>
        </div>
        <div class="td-cnt-body">
            <div *ngFor="let deliveryDate of item?.deliveryDatesCollection; let i = index" class="item">

                <!-- Dates -->
                <ng-container *ngIf="isItdcrSource; else standardDates">
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.BaseDeliveryDate' | translate"
                            [isMobile]="isMobile" [value]="getBaseDeliveryDisplay(deliveryDate)" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.ExtraLeadTime' | translate"
                            [isMobile]="isMobile" [value]="getExtraLeadTimeDisplay()" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.DeliveryWeek' | translate"
                            [isMobile]="isMobile" [value]="getTotalDeliveryDisplay(deliveryDate)" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                </ng-container>
                <ng-template #standardDates>
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.BaseDeliveryDate' | translate"
                            [isMobile]="isMobile" [value]="getBaseDeliveryDisplay(deliveryDate)" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.ExtraLeadTime' | translate"
                            [isMobile]="isMobile" [value]="getExtraLeadTimeDisplay()" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                    <div>
                        <teiasoft-input [type]="'string'" [labelText]="'grid.DeliveryDate' | translate"
                            [isMobile]="isMobile" [value]="getTotalDeliveryDisplay(deliveryDate)" [isValid]="true"
                            [hideLabel]="i > 0"
                            [readOnly]="true">
                        </teiasoft-input>
                    </div>
                </ng-template>

                <!-- Quantity -->
                <div>
                    <teiasoft-input [type]="'number'" [labelText]="'grid.Quantity' | translate" [isMobile]="isMobile"
                        [value]="deliveryDate.deliveryQuantity" [isValid]="true" [readOnly]="true"
                        [hideLabel]="i > 0"></teiasoft-input>
                </div>

                <!-- UOM -->
                <div>
                    <teiasoft-input [type]="'string'" [labelText]="'grid.QuantityUom' | translate" [isMobile]="isMobile"
                        [value]="deliveryDate.deliveryQuantityUom" [isValid]="true" [readOnly]="true"
                        [hideLabel]="i > 0"></teiasoft-input>
                </div>

            </div>
        </div>


        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (click)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [isMobile]="isMobile" class="mr-5"></teiasoft-button>
        </div>
    </div>
</div>
